export enum TypKolumny {
  STRING, NUMBER, BOOLEAN, DATE
}
